import type { OptionsOrGroups, GroupBase } from 'react-select'

import type { SelectOptionInterface } from '@customTypes'

import { isGroup } from '../helpers'

export const getSortedOptions = <
  Opt extends SelectOptionInterface,
  IsMulti extends boolean,
  Group extends GroupBase<Opt>
>(
  options: OptionsOrGroups<Opt, Group>,
  isMulti?: IsMulti,
  value?: Opt['value'][] | Opt['value'] | null
): {
  sortedOptions: Opt[] | OptionsOrGroups<Opt, Group>
  lastSelectedOptions: string[] | undefined
} => {
  if (!isMulti || options.length < 1) {
    return {
      sortedOptions: options,
      lastSelectedOptions: [],
    }
  }
  const newSortedOptions = []
  const ungroupedOptions: Opt[] = []

  options.forEach(option => {
    if (isGroup(option)) {
      const sortedGroupOptions = [...option.options]
      sortedGroupOptions.sort((a: Opt, b: Opt) => {
        if (value && Array.isArray(value)) {
          const aIsSelected = value.find(v => v === a.value)
          const bIsSelected = value.find(v => v === b.value)

          if (aIsSelected && !bIsSelected) {
            return -1
          }
          if (!aIsSelected && bIsSelected) {
            return 1
          }
          return 0
        }
        return 0
      })

      const newOption = { ...option, options: sortedGroupOptions }
      newSortedOptions.push(newOption)
    } else {
      ungroupedOptions.push(option)
    }
  })

  newSortedOptions.push(
    ...ungroupedOptions.sort((a: Opt, b: Opt) => {
      if (value && Array.isArray(value)) {
        const aIsSelected = value.find(v => v === a.value)
        const bIsSelected = value.find(v => v === b.value)

        if (aIsSelected && !bIsSelected) {
          return -1
        }
        if (!aIsSelected && bIsSelected) {
          return 1
        }
        return 0
      }
      return 0
    })
  )

  const newLastSelectedOptions = []
  if (value && Array.isArray(value)) {
    let lastSelectedOption
    for (let i = 0; i < options.length; i += 1) {
      const option = options[i]
      let lastSelectedGroupOption
      if (isGroup(option)) {
        const groupOptions = (option as Group).options

        const selectedOptions = groupOptions.filter(v =>
          value.includes(v.value)
        )

        lastSelectedGroupOption = [...selectedOptions].pop()

        if (lastSelectedGroupOption) {
          newLastSelectedOptions.push(lastSelectedGroupOption.label)
        }
      } else {
        const isSelected = value.find(v => v === option.value)
        if (isSelected) {
          lastSelectedOption = option.label
        }
      }
    }

    if (lastSelectedOption) {
      newLastSelectedOptions.push(lastSelectedOption)
    }
  }

  return {
    lastSelectedOptions: newLastSelectedOptions,
    sortedOptions: newSortedOptions,
  }
}
